import RichText from '@shared/h5/components/RichText';
export default RichText;
